import React from "react";
import PropTypes from "prop-types";
import { graphql, StaticQuery } from "gatsby";
import ThoughtSnippet from "./ThoughtSnippet";

class ThoughtsFeed extends React.Component {
  render() {
    const { data } = this.props;
    const { edges: posts } = data.allMarkdownRemark;
    return (
      <>
        {posts &&
          posts.map(({ node: post }) => (
            <ThoughtSnippet post={post} key={post.id} />
          ))}
      </>
    );
  }
}

ThoughtsFeed.propTypes = {
  data: PropTypes.shape({
    allMarkdownRemark: PropTypes.shape({
      edges: PropTypes.array
    })
  })
};

export default () => (
  <StaticQuery
    query={graphql`
      query ThoughtsFeedQuery {
        allMarkdownRemark(
          sort: { order: DESC, fields: [frontmatter___date] }
          filter: {
            frontmatter: {
              draft: { eq: false }
              templateKey: { eq: "thoughts-post" }
            }
          }
        ) {
          edges {
            node {
              excerpt(pruneLength: 400)
              id
              fields {
                slug
              }
              frontmatter {
                title
                subTitle
                templateKey
                date(formatString: "MMMM DD, YYYY")
                featuredPost
                featuredImage {
                  childImageSharp {
                    fluid(maxWidth: 608, quality: 100) {
                      ...GatsbyImageSharpFluid
                    }
                  }
                }
              }
            }
          }
        }
      }
    `}
    render={(data, count) => <ThoughtsFeed data={data} count={count} />}
  />
);
